<template>
 <v-layout row class="row-body" :style="bgc.background">
        <v-flex style="height: '100%';">
        <div class="item-label" :style="bgc.label">{{args.label}}</div>
        <div class="item-value" :style="bgc.value">{{args.value}}</div>
        </v-flex>
    </v-layout>
</template>

<script>
import ui from '@/../../coreui/helpers/ui'
import {sync} from 'vuex-pathify'
export default {
  props: ["args"],
  computed: {
    dark: sync('misc/dark'),
    bgc() {
      return {
        label: {
          color: this.args.labelTextColor ?? (this.dark ? 'lightblue' : 'blue'),
          backgroundColor: this.args.flat ? ui.theme(this.dark).plainBackground : ui.theme(this.dark).background,
          textAlign: this.args.align ?? 'center',
          fontSize: this.args.labelFontSize ?? '0.9em',
          marginRight: '5px'
        },
        value: {
          color: this.args.valueTextColor ?? (this.dark ? 'white': 'black'),
          backgroundColor: this.args.flat ?  ui.theme(this.dark).plainBackground : ui.theme(this.dark).background,
          textAlign: this.args.align ?? 'center',
          fontSize: this.args.valueFontSize ?? '1.2em',
          marginRight: '5px'
        },
        background: {
          backgroundColor: this.args.flat ?  ui.theme(this.dark).plainBackground : ui.theme(this.dark).background,
          height: '100%'
        }
      }
    }
  },
  mounted () {
    // console.log(this.args)
  }
}
</script>

<style scoped>
.row {
  margin: unset;
}
.row-body {
  height: 100% !important;
}
.item-label {
  padding-top: 3px;
  height: 30%;
  font-size: 0.9em;
}
.item-value {
  padding-top: 5px;
  height: 70%;
  font-size: 1.2em;
}
</style>

